var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { staticClass: "conecta-bajas-cobranza", attrs: { xs12: "", sm12: "" } },
    [
      _c("BajasCobranzaFilters", { on: { filters: _vm.handleFilters } }),
      _c("v-divider"),
      _c("BajasCobranzaActions", {
        attrs: { paramApi: _vm.paramApi, dataList: _vm.dataList }
      }),
      _c("MantenedorGridSinCodigo", {
        attrs: {
          "grid-options": _vm.gridOptions,
          "funcionalidad-id": _vm.funcionalidad
        }
      }),
      _vm.dialogVerDetalle
        ? _c("BajasCobranzaVerDetalle", {
            attrs: { data: _vm.data },
            on: { cerrar: _vm.handleCloseModal }
          })
        : _vm._e(),
      _vm.dialogEditar
        ? _c("BajasCobranzaEditar", {
            attrs: { data: _vm.data, statusFinished: _vm.statusFinished },
            on: { cerrar: _vm.handleCloseModal }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }